// ============================================================================
// This file is PROJECT SPECIFIC
// ============================================================================

// Registration Member Types
const initMemberTypes = () => {
  const countrySelect = document.getElementById("user_country");
  const memberTypeSelect = document.getElementById("user_member_type_id");
  const memberTypeOtherWrapper = document.getElementById("member_type_other_wrapper");
  const memberTypeOtherInput = document.getElementById("user_member_type_other");

  if (!countrySelect || !memberTypeSelect) return;

  // In edit mode the select is disabled; still show/hide the "Other" field.
  if (memberTypeSelect.disabled) {
    updateMemberTypeOtherVisibility();
    return;
  }

  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || "{}");

  function updateMemberTypeOtherVisibility() {
    if (!memberTypeOtherWrapper) return;
    const selectedOption = memberTypeSelect.options[memberTypeSelect.selectedIndex];
    const selectedLabel = selectedOption ? selectedOption.textContent : "";

    if (selectedLabel.includes("Others")) {
      memberTypeOtherWrapper.classList.remove("hidden");
      if (memberTypeOtherInput) memberTypeOtherInput.setAttribute("required", "required");
    } else {
      memberTypeOtherWrapper.classList.add("hidden");
      if (memberTypeOtherInput) memberTypeOtherInput.removeAttribute("required");
    }
  }

  function updateMemberTypeOptions() {
    const selectedCountryCode = countrySelect.value;

    // Clear existing options
    memberTypeSelect.innerHTML = '<option value="">- Select -</option>';

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true;
      return;
    }

    // Filter member types based on country rules
    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData;
      let shouldShow = false;

      switch (country_rule) {
        case "all_countries":
          shouldShow = true;
          break;
        case "specific_countries":
          shouldShow = countries.includes(selectedCountryCode);
          break;
        case "exclude_countries":
          shouldShow = !countries.includes(selectedCountryCode);
          break;
      }

      if (shouldShow) {
        const option = document.createElement("option");
        option.value = id;
        option.textContent = memberTypeName;
        memberTypeSelect.appendChild(option);
      }
    });

    memberTypeSelect.disabled = memberTypeSelect.options.length <= 1;
    updateMemberTypeOtherVisibility();
  }

  countrySelect.addEventListener("change", updateMemberTypeOptions);
  memberTypeSelect.addEventListener("change", updateMemberTypeOtherVisibility);

  // Initialize on page load
  updateMemberTypeOptions();
  updateMemberTypeOtherVisibility();
};

// Initialize all custom functionality
const initMacro2026Registration = () => {
  initMemberTypes();
};

export default initMacro2026Registration;
